export default __webpack_public_path__ + "static/media/eml.c8ea2e7a.svg";